var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11356 9.92925L3.19608 15.2786L8.00007 12.753L12.8041 15.2786L11.8866 9.92925L15.7731 6.14084L10.4021 5.36038L8.00007 0.493408L5.59807 5.36038L0.227051 6.14084L4.11356 9.92925ZM10.454 9.46362L11.0333 12.8411L8.00017 11.2465L4.96702 12.8411L5.5463 9.46362L3.09243 7.07169L6.48359 6.57893L8.00017 3.50602L9.51674 6.57893L12.9079 7.07169L10.454 9.46362Z",
    fill: "#FCCC24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M9.60215 6.44282L8.32186 2.40991L6.40143 5.77067L1.92041 7.11497L4.48099 9.80358V13.1643L7.68172 11.82L11.5226 13.1643L10.8824 9.13143L13.443 7.11497L9.60215 6.44282Z",
    fill: "#FCCC24"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c42a69691cfc8059c51dfc0e59c4a891.svg";
export { ForwardRef as ReactComponent };